import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { api } from '../api/stock'

export const fetchStockRange = createAsyncThunk('stock/fetchRange', () => api.getStockRange())

export const fetchStockPrices = createAsyncThunk(
  'stock/fetchPrices',
  ({ symbol, start, end }) => api.getStockPrices(symbol, { start, end })
)

const stockSlice = createSlice({
  name: 'stock',
  initialState: {
    symbol: null,
    start: null,
    end: null,
    range: null,
    rangeLoading: false,
    rangeError: null,
    prices: [],
    loading: false,
    error: null,
  },
  reducers: {
    setSymbol(state, action) {
      state.symbol = action.payload
    },
    setDateRange(state, action) {
      state.start = action.payload.start
      state.end = action.payload.end
    },
    clearSymbol(state) {
      state.symbol = null
      state.prices = []
      state.start = null
      state.end = null
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStockRange.pending, (state) => {
        state.rangeLoading = true
        state.rangeError = null
      })
      .addCase(fetchStockRange.fulfilled, (state, action) => {
        state.rangeLoading = false
        state.range = action.payload
      })
      .addCase(fetchStockRange.rejected, (state, action) => {
        state.rangeLoading = false
        state.rangeError = action.error.message
      })
      .addCase(fetchStockPrices.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchStockPrices.fulfilled, (state, action) => {
        state.loading = false
        state.prices = action.payload.prices
        state.start = action.payload.start
        state.end = action.payload.end
      })
      .addCase(fetchStockPrices.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })
  },
})

export const { setSymbol, setDateRange, clearSymbol } = stockSlice.actions
export default stockSlice.reducer
